import NewsPage from './news/NewsPage';
import ProductPage from './product/ProductPage';
import { useNavigationContext } from '../../../contexts/NavigationContext';
import ContentPage from './content/ContentPage';
import MainLayout from '../../../components/Display/MainLayout';

function Home() {
  const { navigationContext } = useNavigationContext();
  return (
    <MainLayout enableAnalytics={false} scope={'caeterra'} websiteLabel={"caeterra.fr"}>
      <ContentPage isActive={navigationContext.activeAppKey === 'content'} />
      <NewsPage isActive={navigationContext.activeAppKey === 'news'} />
      <ProductPage isActive={navigationContext.activeAppKey === 'product'} />
    </MainLayout>
  );
}

export default Home;
